
export enum Section {
  Home = 'Home',
  Work = 'Work',
  Skills = 'Skills',
  About = 'About',
  Contact = 'Contact'
}

export interface Project {
  id: string;
  title: string;
  description: string;
  fullDescription: string;
  challenge: string;
  solution: string;
  image: string;
  tags: string[];
  link?: string;
  year: string;
}

export interface Skill {
  category: string;
  items: string[];
}
